import axios from 'axios'
import config from '../config/app'

const referralCodeAPI = {
  check (code, data = null) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/referral-code/check/' + code, data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  update (id, data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/referral-code/' + id, data).then((response) => {
        resolve(response)
      }, (error) => {
        reject(error)
      })
    })
  },
  create (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/referral-code', data).then((response) => {
        resolve(response)
      }, (error) => {
        reject(error)
      })
    })
  },
  getById (id, additionalFields) {
    return new Promise((resolve, reject) => {
      this.get({id: id}, additionalFields).then((response) => {
        resolve(response.data[0])
      }, (error) => {
        reject(error)
      })
    })
  },
  getByCode (code, additionalFields) {
    return new Promise((resolve, reject) => {
      this.get({code: code}, additionalFields).then((response) => {
        resolve(response.data[0])
      }, (error) => {
        reject(error)
      })
    })
  },
  getAll (additionalFields) {
    return this.get({}, additionalFields)
  },

  get (params, additional) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + '/referral-code?' + stringParams

    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getReferralGoods (params, additional = null) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + '/referral-good?' + stringParams

    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  createReferralGood (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/referral-good', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  updateReferralGood (id, data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/referral-good/' + id, data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  deleteReferralGood (id) {
    return new Promise((resolve, reject) => {
      axios.delete(config.server + '/referral-good/' + id).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getSpecialImpact () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/referral-code/special-impact').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  sendSegment (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/referral-code/referral-details', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getCouponCodes (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/referral-code/get-used-codes', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  }
}

export default referralCodeAPI



// WEBPACK FOOTER //
// ./src/api/referralCode.js